<template>
    <div class="play-list" :class="{'is-active': playing}" :queue-table-playList="JSON.stringify(queuePlayList)">
        <div class="play-list__icon">
            <IconVolume/>
        </div>
        <audio ref="auto" src="../../assets/audio/song.mp3"></audio>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import UUID from 'uuidjs'
import Helper from '@/utils/helper'
// components
import IconVolume from '@/components/Icons/IconVolume'
import * as types from '@/store/types'

const IN_QUEUE = 1
const CALLED = 2
const POSTPONED = 3
const SERVICING = 4

export default {
    name: 'PlayList',
    components: {
        IconVolume
    },
    data () {
        return {
            playing: false,
            queuePlayList: [],
            historyPlayListItem: [],
            timeoutId: null
        }
    },
    computed: {
        ...mapState({
            playListItems: state => state.playlist.items,
            tickets: state => state.board.tickets,
            soundStates: state => state.board.states.filter(elem => elem.soundType),
            totalVolume: state => state.playlist.volumeSetting.getVolumeLevelTotal()
        })
    },
    watch: {
        queuePlayList () {
            // При изменение очереди, начинается воспроизведение
            if (!this.playing) {
                this.playTrackList()
            }
        },
        playListItems () {
            const freezePlayListItems = this.playListItems.map((item) => {
                return { ...item }
            })

            this.queuePlayList.push({
                playListItems: freezePlayListItems,
                uuid: UUID.generate()
            })
        }
    },
    methods: {
        ...mapActions({
            playlistSpeakIdSet: types.PLAYLIST.speakId.set,
            playlistSpeakIdReset: types.PLAYLIST.speakId.reset,
            mediaMuteSet: types.PLAYLIST.mediaMute.set,
            mediaMuteReset: types.PLAYLIST.mediaMute.reset
        }),
        async playTrackList () {
            this.playing = true
            clearTimeout(this.timeoutId)
            if (this.queuePlayList.length > 0) {
                for (const queueItem of this.queuePlayList) {
                    for (const playListItems of queueItem.playListItems) {
                        await this.playTracks(playListItems)
                    }
                    // Удаление из очереди
                    this.queuePlayList = this.queuePlayList.filter(playList => playList.uuid !== queueItem.uuid)
                }
            }

            return new Promise((resolve) => {
                this.playing = false
                resolve()
            })
        },
        async playTracks (item) {
            let canPlay = true
            const itemInHistory = this.historyPlayListItem.find(el => el.id === item.id)
            const hasItemInCurrentTicket = this.tickets.find(el => el.id === item.id)
            if (hasItemInCurrentTicket) {
                // Проверка по истории
                if (itemInHistory) {
                    canPlay = itemInHistory.callCount < item.callCount ||
                        (itemInHistory.screenStateId === CALLED && item.screenStateId === POSTPONED) ||
                        (itemInHistory.screenStateId === POSTPONED && item.screenStateId === IN_QUEUE) ||
                        (itemInHistory.screenStateId === SERVICING && item.screenStateId === IN_QUEUE)
                }
                if (canPlay) {
                    this.playlistSpeakIdSet(item.id)

                    if (Helper.isDefined(item.tracks)) {
                        this.addSounds(item.tracks)
                        this.setTotalVolume(this.totalVolume)
                        this.mediaMuteSet()
                        await this.playAllSounds()
                    } else {
                        if (this.soundStates.map(elem => elem.id).includes(item.screenStateId)) {
                            this.mediaMuteSet()
                            await this.playSystemTrack()
                        } else {
                            await this.playWithoutSound()
                        }
                    }

                    if (itemInHistory) {
                        itemInHistory.callCount = item.callCount
                        itemInHistory.screenStateId = item.screenStateId
                    } else {
                        this.historyPlayListItem.push(item)
                    }
                }
            }
            return new Promise((resolve) => {
                this.playlistSpeakIdReset()
                this.mediaMuteReset()
                resolve()
            })
        },
        playSystemTrack () {
            clearTimeout(this.timeoutId)
            return new Promise((resolve) => {
                this.$refs.auto.load()
                this.$refs.auto.volume = this.totalVolume
                this.$refs.auto
                    .play()
                    .finally(() => {
                        this.timeoutId = setTimeout(() => {
                            resolve()
                            clearTimeout(this.timeoutId)
                        }, 1200)
                    })
            })
        },
        playWithoutSound () {
            this.mediaMuteReset()
            clearTimeout(this.timeoutId)
            return new Promise(resolve => {
                this.timeoutId = setTimeout(() => {
                    resolve()
                    clearTimeout(this.timeoutId)
                }, 1200)
            })
        }
    }
}
</script>
